export default __webpack_public_path__ + "static/media/logoFooter.5dc07096.svg";